import { TextField } from "@mui/material";
import { useEffect } from "react";

const SearchBar = ({ value, setValue, SearchValue, placeholder, style }) => {
  useEffect(() => {
    let timeout = setTimeout(() => {
      SearchValue();
    }, 1000);

    return () => clearTimeout(timeout);
  }, [value]);
  return (
    <TextField
      value={value}
      onChange={setValue}
      fullWidth
      size="small"
      placeholder="Search by name, description"
      sx={{ mb: 2 }}
    />
  );
};

export default SearchBar;
